import {useEffect, useState} from "react";
import {useSearchParams, useNavigate} from "react-router-dom";
import { API_BASE_URL } from "../config";

const FALLBACK_REDIRECT = "/subscriptions";

export const CallbackPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState<"loading" | "completed" | "failed" | "pending">("loading");
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const redirectTo = (url: string | undefined, delay: number) => {
            setTimeout(() => {
                if (url) {
                    window.location.assign(url);
                } else {
                    navigate(FALLBACK_REDIRECT);
                }
            }, delay);
        };

        const key = searchParams.get("key");
        if (!key) {
            setStatus("failed");
            setError("کلید نامعتبر");
            redirectTo(undefined, 2500);
            return;
        }

        fetch(`${API_BASE_URL}/api/v1/payments/verify?key=${encodeURIComponent(key)}`)
            .then((res) => {
                if (!res.ok) throw new Error("Network response was not ok");
                return res.json();
            })
            .then((data) => {
                const statusVal = data.status as "completed" | "failed" | "pending";
                const redirectUrl = data.redirect_url as string | undefined;
                setStatus(statusVal);

                if (statusVal === "completed") {
                    redirectTo(redirectUrl, 1500);
                } else if (statusVal === "failed") {
                    setError("پرداخت ناموفق");
                    redirectTo(redirectUrl, 2500);
                } else if (statusVal === "pending") {
                    setError("ارسال شما به صفحه درگاه با خطا مواجه شده است. لطفاً با پشتیبانی تماس بگیرید.");
                    redirectTo(redirectUrl, 3500);
                }
            })
            .catch(() => {
                setStatus("failed");
                setError("خطا در بررسی وضعیت پرداخت");
                redirectTo(undefined, 2500);
            });
    }, [searchParams, navigate]);

    if (status === "loading") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <div
                        className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#b45a3a] dark:border-[#e59a7f] mx-auto mb-4"></div>
                    <p className="text-gray-600">در حال بررسی وضعیت پرداخت...</p>
                </div>
            </div>
        );
    }

    if (status === "completed") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-green-50">
                <div className="text-center animate-fade-in">
                    <div className="text-green-600 text-6xl mb-4">✅</div>
                    <h2 className="text-2xl font-bold text-green-800">پرداخت موفق</h2>
                    <p className="text-gray-600 mt-2">در حال هدایت...</p>
                </div>
            </div>
        );
    }

    if (status === "failed") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-red-50">
                <div className="text-center animate-fade-in">
                    <div className="text-red-600 text-6xl mb-4">❌</div>
                    <h2 className="text-2xl font-bold text-red-800">پرداخت ناموفق</h2>
                    {error && <p className="text-red-700 mt-2">{error}</p>}
                    <p className="text-gray-600 mt-4">در حال هدایت...</p>
                </div>
            </div>
        );
    }

    if (status === "pending") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center max-w-md px-6">
                    <div className="text-amber-600 text-6xl mb-4">⚠️</div>
                    <h2 className="text-2xl font-bold text-gray-800">خطا در ارسال به درگاه</h2>
                    {error && <p className="text-gray-700 mt-3">{error}</p>}
                    <p className="text-gray-600 mt-4">در حال هدایت...</p>
                </div>
            </div>
        );
    }

    return null;
};
